import { jsx as _jsx, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
import React from "react";
import iconSizes from "../iconSizes";
import { deprecatedPropValueMessage } from "../../../utils/deprecationUtils";
var isDeprecatedIconSize = function(iconSize) {
    if (typeof iconSize === 'undefined') {
        return false;
    }
    return iconSize === 'xl';
};
var ClipboardCheckIcon = function(param) {
    var _size = param.size, size = _size === void 0 ? 's' : _size, _color = param.color, color = _color === void 0 ? 'currentColor' : _color, title = param.title;
    if (isDeprecatedIconSize(size)) {
        deprecatedPropValueMessage({
            componentName: 'Icon',
            propName: 'size',
            propValue: 'xl',
            date: 'Q3 2022'
        });
    }
    var ref;
    return _jsxs("svg", {
        focusable: "false",
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: '0 0 32 32',
        css: {
            width: iconSizes[size],
            height: iconSizes[size],
            fill: color
        },
        role: "img",
        "aria-hidden": (ref = !title) !== null && ref !== void 0 ? ref : false,
        children: [
            title && _jsx("title", {
                children: title
            }),
            _jsx("g", {
                children: _jsxs("svg", {
                    viewBox: "0 0 24 24",
                    children: [
                        _jsx("path", {
                            d: "M20.715 2.755c-.49-.48-1.15-.75-1.84-.75h-1.99c-.51-.6-1.3-1-2.19-1h-5.4c-.89 0-1.68.4-2.19 1h-1.99c-.7 0-1.35.27-1.84.75s-.77 1.15-.77 1.83v15.83c0 .68.28 1.35.77 1.83s1.15.75 1.84.75h13.76c.7 0 1.35-.27 1.84-.75s.78-1.15.78-1.83V4.585c0-.68-.28-1.35-.77-1.83h-.01zm-11.43.25h5.4c.43 0 .8.27.8.6v.8c0 .33-.37.6-.8.6h-5.4c-.43 0-.8-.27-.8-.6v-.8c0-.33.37-.6.8-.6zm10.2 17.42c0 .15-.06.29-.17.41-.12.11-.28.18-.44.18H5.105c-.17 0-.33-.07-.45-.18a.56.56 0 01-.17-.4V4.585c0-.15.06-.3.17-.4.12-.11.28-.18.45-.18h1.38v.4c0 1.43 1.26 2.6 2.8 2.6h5.4c1.54 0 2.8-1.17 2.8-2.6v-.4h1.38c.17 0 .33.06.45.18.11.11.17.25.17.4v15.84z"
                        }),
                        _jsx("path", {
                            d: "M11.685 17.785c-.19 0-.38-.05-.55-.17l-2.39-1.59a1.01 1.01 0 01-.28-1.39c.31-.46.93-.58 1.39-.28l1.6 1.07 4.21-5.61c.33-.44.96-.53 1.4-.2.44.33.53.96.2 1.4l-4.78 6.37c-.2.26-.5.4-.8.4z"
                        })
                    ]
                })
            })
        ]
    });
};
ClipboardCheckIcon.isCarinaIcon = true;
export default ClipboardCheckIcon;
